import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box, debounce } from '@mui/material';
import { toast } from 'react-toastify';
import {
  getReservationList,
  markTripAsNoShow,
  patchupdateReservation,
} from 'redux/actions/reservationAction';
import AllotVehicleModal from 'pages/operation/allRides/AllotVehicleModal';
import DispatchModal from 'pages/operation/allot/DispatchModal';
import useModal from 'hooks/useModal';
import CancelRegistrationModal from '../cancelRegistrationModal/CancelRegistrationModal';
import AllRidesTabList from './AllRidesTabList';
import { getDateFormat, handlePermissions, checkIsAdmin } from 'utils/utils';
import { filterOperationData } from './AllRidesData';
import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';
import {
  handleExtensionRequestAction,
  provisionNewTripForExtension,
} from 'services/ExtensionRequestService';
import CommonDialog from 'components/commonDialog/CommonDialogV2';
import Loader from 'components/loader/Loader';
import NoShowModal from 'components/noShowModal/NoShowModal';

const AllRides = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const startDate = searchParams?.get('startDate');
  const endDate = searchParams?.get('endDate');
  const filterType = searchParams?.get('type');
  const filterPage = searchParams?.get('page');
  const filterRowPerPage = searchParams?.get('rowPerPage');
  const filterSearch = searchParams?.get('search');

  const { open: allotModal, toggle: setAllotModal } = useModal();
  const { open: dispatchMoal, toggle: setDispatchModal } = useModal();
  const { open: cancelModal, toggle: setCancelModal } = useModal();
  const { open: noShowModal, toggle: setNoShowModal } = useModal();
  const [noShowTripDetails, setNoShowTripDetails] = useState(null);

  // Dialog state for Approve Extension
  const [isApproveExtensionDialogOpen, setIsApproveExtensionDialogOpen] = useState(false);
  const [approveExtensionLoading, setApproveExtensionLoading] = useState(false);
  const [approveExtensionData, setApproveExtensionData] = useState(null);

  // Dialog state for Provision New Trip
  const [isProvisionNewTripDialogOpen, setIsProvisionNewTripDialogOpen] = useState(false);
  const [provisionNewTripLoading, setProvisionNewTripLoading] = useState(false);
  const [provisionNewTripData, setProvisionNewTripData] = useState(null);

  // ----FormatingDate---
  const handleDateFormating = (data) => {
    return getDateFormat(data, 'reservationDateFormat');
  };

  const dispatch = useDispatch();
  const { tabs } = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [page, setPage] = useState(filterPage ? parseInt(filterPage) : 0);
  const [rowsPerPage, setRowsPerPage] = useState(filterRowPerPage ? filterRowPerPage : 10);
  const [search, setSearch] = useState(filterSearch ? filterSearch : '');
  const [tab, setTab] = useState(tabs ? tabs : 'all');
  const [status, setStatus] = useState([]);
  const [dateFrom, setDateFrom] = useState(
    startDate && startDate !== 'null'
      ? startDate
      : startDate === 'null'
        ? ''
        : state?.fromTab
          ? state?.dateFrom
          : handleDateFormating(new Date()),
  );
  const [dateTo, setDateTo] = useState(
    endDate && endDate !== 'null'
      ? endDate
      : endDate === 'null'
        ? ''
        : state?.fromTab
          ? state?.dateTo
          : handleDateFormating(new Date()),
  );
  const [tripDetails, setTripDetails] = useState();
  const [type, setType] = useState(filterType ? filterType : '');
  const reservationList = useSelector((state) => state.getReservationList?.reservationList?.data);

  const getFilteredReservationList = () => {
    if (!reservationList) return reservationList;
    if (tab === 'booked') {
      return {
        ...reservationList,
        body: reservationList?.body?.filter((ele) => {
          const statusLower = ele.status?.toLowerCase() || '';
          const isAllottedSubvendor =
            (ele?.subVendorCompanyId ||
              ele?.additionalInfo?.subVendorAssignment?.subVendorCompanyId ||
              ele?.subVendorCompany ||
              ele?.additionalInfo?.subVendorAssignmentStatus === 'alloted') &&
            ele?.additionalInfo?.subVendorAssignmentStatus !== 'rejected';
          return statusLower === 'booked' && !isAllottedSubvendor;
        }),
      };
    }
    return reservationList;
  };

  let paramsList = {};

  searchParams.forEach((value, key) => {
    paramsList[key] = value;
  });

  let filterData = {
    B2B: true,
    status:
      tab === 'completed'
        ? 'completed'
        : tab === 'cancelled'
          ? 'cancelled'
          : tab === 'booked'
            ? 'booked'
            : tab === 'closed'
              ? 'closed'
              : status,
    page: page,
    dateFrom: dateFrom,
    dateTo: dateTo,
    pageSize: rowsPerPage,
    search: search,
    type: type,
  };

  useEffect(() => {
    if (tab !== 'all') {
      dispatch(getReservationList({ ...filterData, status: tab }));
    } else {
      dispatch(getReservationList(filterData));
    }
    setTab(tab);
  }, []);

  const onClickMoreIcon = (tripData, ele) => {
    if (ele === 'Re-Allot') {
      setTripDetails(tripData);
      setAllotModal();
    } else if (ele === 'Cancel Duty') {
      setTripDetails(tripData);
      setCancelModal();
    } else if (ele === 'vip') {
      const payloadData = {
        id: tripData?.id,
        formData: {
          isVip: tripData?.isVip ? false : true,
          type: tripData?.type,
        },
      };

      dispatch(patchupdateReservation(payloadData, 'listPage'));
    } else if (ele === 'Approve Extension') {
      const extensionRequestId = tripData?.extensionRequests?.[0]?.id;
      if (extensionRequestId) {
        setApproveExtensionData(tripData);
        setIsApproveExtensionDialogOpen(true);
      } else {
        toast.error('Extension request ID not found');
      }
    } else if (ele === 'Provision New Trip') {
      const extensionRequestId = tripData?.extensionRequests?.[0]?.id;
      if (extensionRequestId) {
        setProvisionNewTripData(tripData);
        setIsProvisionNewTripDialogOpen(true);
      } else {
        toast.error('Trip ID not found');
      }
    }
  };

  const onMarkNoShow = (tripData) => {
    setNoShowTripDetails(tripData);
    setNoShowModal();
  };

  const handleNoShowSubmit = (noShowData) => {
    dispatch(markTripAsNoShow(noShowData, 'listPage'));
    setNoShowModal();
    setNoShowTripDetails(null);
  };

  const handleTab = (tabValue) => {
    navigate(`/operation/allrides/${tabValue}`);
    setStatus([]);
    setSearch('');
    setType([]);
    setPage(0);
    setRowsPerPage(10);
    setDateFrom(handleDateFormating(new Date()));
    setDateTo(handleDateFormating(new Date()));
    setTab(tabValue);

    filterData['status'] = tabValue !== 'all' ? tabValue : '';
    filterData['search'] = '';
    filterData['type'] = '';
    filterData['page'] = 0;
    filterData['pageSize'] = 10;
    filterData['dateTo'] = handleDateFormating(new Date());
    filterData['dateFrom'] = handleDateFormating(new Date());
    dispatch(getReservationList(filterData));
  };

  const onSearchQuery = debounce((val) => {
    setSearchParams({ ...paramsList, page: 0, search: val });
    setPage(0);
    setSearch(val);
    filterData = {
      ...filterData,
      search: val,
      pageSize: '',
      status:
        tab === 'booked'
          ? 'booked'
          : tab === 'cancelled'
            ? 'cancelled'
            : tab === 'completed'
              ? 'completed'
              : tab === 'closed'
                ? 'closed'
                : '',
      page: 0,
    };
    dispatch(getReservationList(filterData));
  }, 500);

  const handleChangePage = (event, newPage) => {
    setSearchParams({ ...paramsList, page: newPage });
    setPage(newPage);
    dispatch(getReservationList({ ...filterData, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setSearchParams({
      ...paramsList,
      rowPerPage: parseInt(event.target.value),
      page: 0,
    });
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(
      getReservationList({
        ...filterData,
        page: 0,
        pageSize: parseInt(event.target.value),
      }),
    );
  };

  const onFilterChange = (val) => {
    setPage(0);
    const defaultDuty = ['Airport', 'B2bRental', 'OutStationOneWay', 'OutStationRound'];
    const filterLocations = val.filter((location) => {
      return defaultDuty.includes(location);
    });

    setType(filterLocations);
    setSearchParams({ ...paramsList, type: filterLocations?.toString() });

    const reservationFilterData = {
      ...filterData,
      type: filterLocations?.toString(),
      page: 0,
    };
    dispatch(getReservationList(reservationFilterData));
  };

  const onRestFilter = () => {
    setType([]);
    setSearchParams({ ...paramsList, type: '' });

    dispatch(getReservationList({ ...filterData, type: '' }));
  };

  const onSelectDateRange = (newValue) => {
    if (newValue === null || newValue === 0) {
      setSearchParams({ ...paramsList, startDate: 'null', endDate: 'null' });
      setDateFrom('');
      setDateTo('');
      filterData = { ...filterData, dateFrom: '', dateTo: '' };
    } else {
      setSearchParams({
        ...paramsList,
        startDate: handleDateFormating(newValue[0]),
        endDate: handleDateFormating(newValue[1]),
      });
      setDateFrom(handleDateFormating(newValue[0]));
      setDateTo(handleDateFormating(newValue[1]));
      filterData = {
        ...filterData,
        dateFrom: handleDateFormating(newValue[0]),
        dateTo: handleDateFormating(newValue[1]),
      };
    }

    dispatch(getReservationList(filterData));
  };

  const tableOnClickRow = (navigate, val) => {
    navigate(
      `/operation/allrides/bookingdetails?id=${val.id}&startDate=${dateFrom}&endDate=${dateTo}&type=allrides&page=${page}&rowPerPage=${rowsPerPage}&search=${search}&tab=${tab}`,
    );
  };

  const handleOperation = (event, status, ele) => {
    event.preventDefault();
    event.stopPropagation();
    if (status === 'Booked') {
      setTripDetails(ele);
      setAllotModal();
    } else if (status === 'Alloted') {
      setDispatchModal();
      setTripDetails(ele);
    }
  };

  const role = localStorage.getItem('role');
  const isAdmin = checkIsAdmin();

  const roleAndPermissions = useSelector(
    (state) => state?.getRolesAndPermissions?.rolesAndPermissions,
  );
  const allRides = roleAndPermissionEnum.operation;
  const accessForCancel = handlePermissions(roleAndPermissions, allRides.moduleKey, {
    customAccess: allRides.allRides.allRidesCancel,
  });
  const accessForAllot = handlePermissions(roleAndPermissions, allRides.moduleKey, {
    customAccess: allRides.allRides.allRidesAllot,
  });
  const accessForReallot = handlePermissions(roleAndPermissions, allRides.moduleKey, {
    customAccess: allRides.allotTrip.allotTripReallot,
  });
  const accessForAllotAndCancel = accessForCancel && (isAdmin ? accessForReallot : accessForAllot);

  // Handle Approve Extension confirmation
  const handleApproveExtensionConfirm = async () => {
    const extensionRequestId = approveExtensionData?.extensionRequests?.[0]?.id;
    setApproveExtensionLoading(true);
    try {
      const res = await handleExtensionRequestAction(extensionRequestId, 'approve');
      if (res?.success) {
        toast.success(res?.message || 'Extension request approved successfully');
        setIsApproveExtensionDialogOpen(false);
        setApproveExtensionData(null);
        dispatch(getReservationList(filterData));
      } else {
        toast.error(res?.message || 'Failed to approve extension request');
      }
    } catch (error) {
      toast.error(error?.message || 'Failed to approve extension request');
      console.error('Extension Request Error:', error);
    } finally {
      setApproveExtensionLoading(false);
    }
  };

  // Handle Provision New Trip confirmation
  const handleProvisionNewTripConfirm = async () => {
    const extensionRequestId = provisionNewTripData?.extensionRequests?.[0]?.id;
    setProvisionNewTripLoading(true);
    try {
      const res = await provisionNewTripForExtension(extensionRequestId);
      if (res?.success) {
        toast.success(res?.message || 'New trip provisioned successfully');
        setIsProvisionNewTripDialogOpen(false);
        setProvisionNewTripData(null);
        dispatch(getReservationList(filterData));
      } else {
        toast.error(res?.message || 'Failed to provision new trip');
      }
    } catch (error) {
      toast.error(error?.message || 'Failed to provision new trip');
      console.error('Provision New Trip Error:', error);
    } finally {
      setProvisionNewTripLoading(false);
    }
  };

  return (
    <Box className="allrides-container">
      <AllRidesTabList
        page={page}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        onSearchQuery={onSearchQuery}
        reservationList={getFilteredReservationList()}
        tableOnClickRow={tableOnClickRow}
        onSelectDateRange={onSelectDateRange}
        handleTab={handleTab}
        handleOperation={handleOperation}
        onClickMoreIcon={onClickMoreIcon}
        onFilterChange={onFilterChange}
        onRestFilter={onRestFilter}
        filterData={filterOperationData}
        defaultLocation={type}
        dateFrom={dateFrom}
        dateTo={dateTo}
        tab={tab}
        search={search}
        isAdmin={isAdmin}
        accessForOperations={accessForAllot}
        accessForReallot={isAdmin ? accessForReallot : accessForAllot}
        accessForCancel={accessForCancel}
        accessForAllotAndCancel={accessForAllotAndCancel}
        viewMoreIcon={
          isAdmin ? accessForCancel || accessForReallot : accessForCancel || accessForAllot
        }
        onMarkNoShow={accessForCancel || isAdmin ? onMarkNoShow : undefined}
      />
      <AllotVehicleModal
        open={allotModal}
        toggle={setAllotModal}
        tripDetails={tripDetails}
        page={'listPage'}
        payload={filterData}
      />
      <DispatchModal
        open={dispatchMoal}
        toggle={setDispatchModal}
        tripDetails={tripDetails}
        page={'listPage'}
        payload={filterData}
      />
      {/* {cancelModal && (
        <CancelRegistrationModal
          page={"listPage"}
          open={cancelModal}
          toggle={setCancelModal}
          reservationData={tripDetails}
          payload={filterData}
        />
      )} */}

      <CancelRegistrationModal
        page={'listPage'}
        open={cancelModal}
        toggle={setCancelModal}
        reservationData={tripDetails}
        payload={filterData}
      />

      {noShowModal && (
        <NoShowModal
          open={noShowModal}
          toggle={setNoShowModal}
          tripDetails={noShowTripDetails}
          onSubmit={handleNoShowSubmit}
        />
      )}

      {/* Approve Extension Dialog */}
      <CommonDialog
        open={isApproveExtensionDialogOpen}
        handleClose={() => {
          if (!approveExtensionLoading) {
            setIsApproveExtensionDialogOpen(false);
            setApproveExtensionData(null);
          }
        }}
        toggle={setIsApproveExtensionDialogOpen}
        onConfirmDialog={handleApproveExtensionConfirm}
        isLoading={approveExtensionLoading}
        text={
          approveExtensionLoading ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100px',
              }}
            >
              <Loader height="100px" />
            </Box>
          ) : (
            `Are you sure you want to exted the trip: ${approveExtensionData?.tripId || 'this trip'}?`
          )
        }
        selectType="approve"
        typeOfDialog="Extension"
        confirmButtonLabel="Confirm"
      />

      {/* Provision New Trip Dialog */}
      <CommonDialog
        open={isProvisionNewTripDialogOpen}
        handleClose={() => {
          if (!provisionNewTripLoading) {
            setIsProvisionNewTripDialogOpen(false);
            setProvisionNewTripData(null);
          }
        }}
        toggle={setIsProvisionNewTripDialogOpen}
        onConfirmDialog={handleProvisionNewTripConfirm}
        isLoading={provisionNewTripLoading}
        text={
          provisionNewTripLoading ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100px',
              }}
            >
              <Loader height="100px" />
            </Box>
          ) : (
            `Are you sure you want to provision a new trip to extend current trip: ${provisionNewTripData?.tripId || 'this trip'} this requires you to allot and dispatch driver?`
          )
        }
        selectType="provision"
        typeOfDialog="New Trip"
        confirmButtonLabel="Confirm"
      />
    </Box>
  );
};

export default AllRides;
